module.exports = __webpack_public_path__ + "static/4-interlocking-lines-f72a81cbd98975e6c466b73570fb53a2.png";